import { IconButton, Menu, MenuItem, Button, withStyles } from '@material-ui/core';
import EllipseIcon from '@material-ui/icons/MoreVert';
import React from 'react';
import styled from 'styled-components';
import ActionsContextV2 from '../ActionsContextV2';

const StyledButton = withStyles({
    root: {
        minWidth: 20
    }

})(Button);

const ActionFormMenuV2 = ({ action, isLevel1, handleSetAllToYesMenue, IsEnableSetAllToYesMenu = 0 }) => {
    const context = React.useContext(ActionsContextV2)
    const [anchorEl, setAnchorEl] = React.useState(null);
    return (
        <>
            <StyledButton
                variant="contained"
                aria-controls="simple-menu"
                aria-haspopup="true"
                color='primary'
                onClick={event => {
                    setAnchorEl(event.currentTarget)
                }}>
                <EllipseIcon />
            </StyledButton>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
            >
                <MenuItem
                    disabled={!isLevel1}
                    onClick={() => {
                        setAnchorEl(null);
                        if (!context.editAlternateSdn) {
                            context.showSnackBarMessage("Adding an alternate SDN will replace the original SDN in your completed procedures manual.                   This is not a deviation.", null, 4000);
                        }
                        context.setEditAlternateSdn(!context.editAlternateSdn);
                    }}
                >
                    {context.editAlternateSdn ? `Hide Alternate SDN Button` : `Add alternate SDN`}
                </MenuItem>
                <MenuItem
                    // disabled={action.activeOneTimeDeviation}
                    onClick={() => {
                        setAnchorEl(null);
                        context.setDownloadProcedures(true);
                    }}
                >
                    Download Procedures
                </MenuItem>
                <MenuItem
                    // disabled={setAllToComplyAsIsFlag}
                    disabled={!IsEnableSetAllToYesMenu}
                    onClick={
                        handleSetAllToYesMenue
                    }
                >
                    Set All to Comply As-Is
                </MenuItem>
            </Menu >
        </>
    );
}

export default ActionFormMenuV2;